module.exports = __webpack_public_path__ + "static/img/14.7918de2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/sp/14.png
// module id = juUE
// module chunks = 0